import { Dispatch } from 'react';
import { actionTypes } from '../../../../types';

export default function CheckBoxFilter({
  dispatch,
  state,
  data,
  isDataFiltered,
}: {
  dispatch: Dispatch<any>;
  state: any;
  data: any[];
  isDataFiltered?: boolean;
}) {
  return data.length > 0 ? (
    <input
      type="checkbox"
      onChange={e => {
        const { checked } = e.target;
        if (checked) {
          dispatch({
            type: actionTypes.SET_CHECK_ALL,
            payload: data.map((row: any) => row['@id']),
          });
        } else {
          dispatch({
            type: actionTypes.UNCHECK_ALL,
            payload: isDataFiltered ? data.map((row: any) => row['@id']) : null,
          });
        }
      }}
      checked={
        isDataFiltered
          ? data.every((row: any) => state.rowChecked.includes(row['@id']))
          : state.rowChecked.length === data.length
      }
    />
  ) : null;
}
